"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNoEmbeddingProperty = exports.noEmbeddingPropertyDefinition = void 0;
exports.noEmbeddingPropertyDefinition = {
    name: 'no-embedding',
    type: 'boolean',
    constraints: [],
    multiple: false,
    default: false,
    view: {
        label: 'Disable embedding',
        hint: 'Disable embed code sharing',
    },
};
const isNoEmbeddingProperty = (prop) => {
    return prop.name === exports.noEmbeddingPropertyDefinition.name;
};
exports.isNoEmbeddingProperty = isNoEmbeddingProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm8tZW1iZWRkaW5nLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvbm8tZW1iZWRkaW5nLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLGNBQWM7SUFDcEIsSUFBSSxFQUFFLFNBQVM7SUFDZixXQUFXLEVBQUUsRUFBRTtJQUNmLFFBQVEsRUFBRSxLQUFLO0lBQ2YsT0FBTyxFQUFFLEtBQUs7SUFDZCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsbUJBQW1CO1FBQzFCLElBQUksRUFBRSw0QkFBNEI7S0FDbkM7Q0FDOEIsQ0FBQTtBQUkxQixNQUFNLHFCQUFxQixHQUFHLENBQUMsSUFBa0IsRUFBK0IsRUFBRTtJQUN2RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsscUNBQTZCLENBQUMsSUFBSSxDQUFBO0FBQ3pELENBQUMsQ0FBQTtBQUZZLFFBQUEscUJBQXFCLHlCQUVqQyJ9